export const CompanyCode = {
    /** 西部ガス */
    saibugas: "00001",
} as const;